import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import Guide from '../components/guide';
export class AppSetupGuide extends PureComponent {
    render() {
        return (_jsx(Guide, { children: _jsx("elevio-element", { "data-type": "article", "data-id": "133" }) }));
    }
}
